import { useLocation } from 'react-router-dom';

import { getRouteByPathname } from 'plugins/router';

const Loader = (): JSX.Element => {
  const { pathname } = useLocation();

  const { skeleton } = getRouteByPathname(pathname) || {};

  return <>{skeleton}</>;
};

export default Loader;
